import { css } from 'styled-components';

import { CTAtertiarySkin } from './CTA.tertiary';

const CTAinlineLinks = css`
  ${CTAtertiarySkin};
  position: relative;
  text-decoration: none;
  background-image: linear-gradient(currentColor, currentColor);
  background-position: 0 100%; /* Start bottom */
  background-repeat: no-repeat;
  background-size: 0% 1px;
  transition: background-size 0.3s ease-in-out;
  padding: 0;
  &:hover {
    background-size: 100% 1px;
  }
`;

export default CTAinlineLinks;
